import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import Button from "./components/button.jsx";
import TextInput from "./components/textBox";
import DropDown from "./components/dropdown.jsx";
import CodeBox from "./components/codeBox.jsx";
import Alert from "@mui/material/Alert";
import ReCAPTCHA from 'react-google-recaptcha'
import { TextField } from "@mui/material";
import { withTranslation } from 'react-i18next';

class SignUp extends React.Component {
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      email: "",
      password: "",
      repassword: "",
      phone: "+9665",
      Emailfail: false,
      Passfail: false,
      rePassfail: false,
      phonefail: false,
      codebox: false,
      notUnique: false,
      activebutton: Colors.lightGray,
      disableButton: true,
      edu: "",
      captchaFail: false,
      topAlertMessage: "",
      generalError: false
    };
    this.recaptcha = React.createRef();
    
  }
  //check if the fields are not empty and the inputs are acceptable then activate the button if true
  checkEmpty() {
    const {
      email,
      password,
      repassword,
      phone,
      Emailfail,
      Passfail,
      rePassfail,
      phonefail,
      edu
    } = this.state;

    if (
      email &&
      password &&
      repassword &&
      edu &&
      phone.length == 13 &&
      !(Emailfail || Passfail || rePassfail || phonefail)
    ) {
      this.setState({ activebutton: Colors.buttonColor, disableButton: false });
      return false;
    } else {
      this.setState({ activebutton: Colors.lightGray, disableButton: true });
      return true;
    }
  }

  // handle the email changing in the text field and checks if the email is in email format by using a regex
  handleEmailChange = (value) => {
    // Do something with the input value
    this.setState({ email: value, notUnique: false }, () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.state.email)) {
        this.setState({ Emailfail: true }, this.checkEmpty);
      } else {
        this.setState({ Emailfail: false }, this.checkEmpty);
      }
    });
  };
  handleEduChange = (value) => {
    // Do something with the input value
    this.setState({ edu: value }, this.checkEmpty);
  };

  // handle the password changing in the text field and checks password is the right strength by using a regex
  handlePasswordChange = (value) => {
    // Do something with the input value
    this.setState({ password: value }, () => {
      this.matchPass();
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
      if (
        !passwordRegex.test(this.state.password) ||
        this.state.password.length < 8
      ) {
        this.setState({ Passfail: true }, this.checkEmpty);
      } else {
        this.setState({ Passfail: false }, this.checkEmpty);
      }
    });
  };
  // handle the password re-entry changing in the text field and if it is equal to the password
  handleRePasswordChange = (value) => {
    // Do something with the input value
    this.setState({ repassword: value }, this.matchPass);
  };
  matchPass() {
    if (
      this.state.password !== this.state.repassword &&
      this.state.repassword
    ) {
      this.setState({ rePassfail: true }, this.checkEmpty);
    } else {
      this.setState({ rePassfail: false }, this.checkEmpty);
    }
  }
  // handle the phone number changing in the text field and checks number is a saudi number by using a regex
  handlePhoneChange = (value) => {
    // Do something with the input value
    this.setState({ phone: value, notUnique: false }, () => {
      const phoneRegex = /^\+9665[0-9]{8}$/;
      if (!phoneRegex.test(this.state.phone)) {
        this.setState({ phonefail: true }, this.checkEmpty);
      } else {
        this.setState({ phonefail: false }, this.checkEmpty);
      }
    });
  };

  submitOnEnter = (e) => {
    if (e.key === "Enter" && !this.checkEmpty()) {
      this.SignUpOnClick();
    }
    if (e.key === " ") {
      this.setState({ codebox: true });
    }
  };

  //sign up function that sends a create request with all the fields
  SignUpOnClick() {

    const captchaValue = this.recaptcha.current.getValue();
    if (!captchaValue) {
      this.setState({
        captchaFail: true
      });
      return;
    } 

    // Build the form
    const formData = new FormData();
    formData.append("email", this.state.email);
    formData.append("password", this.state.password);
    formData.append("phone", this.state.phone);
    formData.append("education_level", this.state.edu);
    formData.append("operation", "create");
    formData.append("captcha_value", captchaValue)
    // Submit the form
    fetch(`/accounts/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    }).then((response) => {
      //check response
      if (response.ok) {
        this.setState({ codebox: true }); // open the confirmation box
      } else if (response.status == 409) {
        this.setState({ notUnique: true, topAlertMessage:this.props.t("signup_email_inuse")});
      }
      else {
        this.setState({ generalError: true, topAlertMessage: this.props.t("signup_general_error")});
      }
      return response.json().then((data) => {
          if (data.name == "EmailThresholdReached") {
            this.setState({ generalError: true, topAlertMessage: this.props.t("signup_attempts_error")});
          }
      })
    })
  }
  handleCodeBox = (value) => {
    this.setState({ codebox: value });
  };
  render() {
    // state variables
    const {
      disableButton,
      activebutton,
      email,
      password,
      phone,
      repassword,
      edu,
      eduOptions,
      Passfail,
      rePassfail,
      Emailfail,
      phonefail,
      notUnique,
      codebox,
      captchaFail,
      topAlertMessage,
      generalError
    } = this.state;

    // Render sign up page

    return (
      <MainCol dir={this.props.i18n.dir()}>
        <NavBar/>
        <Page>
          {codebox && <CodeBox handleVisiblity={this.handleCodeBox} />}
          <h1>{this.props.t("signup_header")}</h1>
          {(notUnique || generalError) && (
            <Alert severity="error">{topAlertMessage}</Alert>
          )}
          <TextInput
            onKeyDown={this.submitOnEnter}
            value={email}
            placeholder={this.props.t("signup_email")}
            func={this.handleEmailChange}
            isfailed={Emailfail || notUnique}
          />
          {Emailfail && <Alert severity="error">{this.props.t("signup_email_invalid")}</Alert>}
          <TextInput
            type="password"
            value={password}
            placeholder={this.props.t("signup_password")}
            func={this.handlePasswordChange}
            isfailed={Passfail}
          />
          {Passfail && (
            <Alert severity="error">
              {this.props.t("signup_password_alert")}
            </Alert>
          )}
          <TextInput
            type="password"
            value={repassword}
            placeholder={this.props.t("signup_password_reentry")}
            func={this.handleRePasswordChange}
            isfailed={rePassfail}
          />
          {rePassfail && (
            <Alert severity="error">{this.props.t("signup_password_reentry_alert")}</Alert>
          )}
          <TextInput 
            style = {{direction: "ltr"}}
            value={phone}
            placeholder={this.props.t("signup_phone")}
            func={this.handlePhoneChange}
            isfailed={phonefail || notUnique}
          />
          {phonefail && <Alert severity="error">{this.props.t("signup_phone_alert")}</Alert>}
          <DropDown
            value={edu}
            placeholder={this.props.t("signup_edu")}
            func={this.handleEduChange}
            options={this.props.t('signup_edu_options', { returnObjects: true })}
          />
          <Button
            disable={disableButton}
            title={this.props.t("signup_button")}
            func={() => this.SignUpOnClick()}
            color={activebutton}
            textColor={Colors.white}
          />
          {captchaFail && <Alert severity="error">{this.props.t("signp_captcha_error")}</Alert>}
          <ReCAPTCHA ref={this.recaptcha} sitekey="6LdzK2AqAAAAAKvla18dQdABViBMB6kBsoiwQqx5"/>
        </Page>
        <Footer />
      </MainCol>
    );
  }
}
export default withTranslation()(SignUp);

// Create a flex column display div
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: space-around;
`;

const MainCol = styled(FlexCol)`
  justify-content: space-between;
  height: 100vh;
  margin-top:50px;
`;

// Create a flex column display div
const Page = styled(FlexCol)`
  align-items: center;
  justify-items: space-around;
  width: 20%;
    min-width:300px;

`;
